import { useAppSelector } from 'app/hooks';
import { isHybridOnlySystemPreference } from 'utils/project';

// Reactive equivalent of utils/project's isHybridOnlyPreference() (which
// reads the store singleton imperatively) — the hybrid mirror of
// use-is-ducted-pathway. Components gating render/fetch behavior on the
// hybrid pathway must re-render when system_preference changes.
export default function useIsHybridPathway(): boolean {
  return useAppSelector((state) =>
    isHybridOnlySystemPreference(
      state.project.projectSettings.find(
        (ps) => ps.code === 'system_preference'
      )?.value
    )
  );
}
